import { connect } from 'react-redux'
import {
  getClientSelection,
  getConfigurationSelection,
  getHouseTypeSelection,
  getOffer,
  getPlotSelection,
} from '../selectors'
import { getBudgetOverview } from '../../budget/selectors'
import Offer from '../components/offer'

const mapStateToProps = state => ({
  budgetSelection: getBudgetOverview(state),
  clientSelection: getClientSelection(state),
  configurationSelection: getConfigurationSelection(state),
  houseTypeSelection: getHouseTypeSelection(state),
  offer: getOffer(state),
  plotSelection: getPlotSelection(state),
})

export default connect(
  mapStateToProps,
  null,
)(Offer)



// WEBPACK FOOTER //
// ./src/modules/offer/containers/offer.js